export { default as Img200 } from './processed/200/Discovery-Of-Witches-A-S1.jpg';
export { default as Img400 } from './processed/400/Discovery-Of-Witches-A-S1.jpg';
export { default as Imgthumb } from './processed/thumb/Discovery-Of-Witches-A-S1.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Discovery-Of-Witches-A-S1.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Discovery-Of-Witches-A-S1.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      130,
      60,
      60
    ],
    "_population": 18,
    "_hsl": [
      0,
      0.36842105263157887,
      0.37254901960784315
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      81,
      29,
      30
    ],
    "_population": 51,
    "_hsl": [
      0.9967948717948718,
      0.4727272727272728,
      0.2156862745098039
    ]
  },
  "Muted": {
    "_rgb": [
      172,
      121,
      100
    ],
    "_population": 6,
    "_hsl": [
      0.0486111111111111,
      0.3025210084033614,
      0.5333333333333333
    ]
  },
  "LightMuted": {
    "_rgb": [
      201,
      171,
      158
    ],
    "_population": 337,
    "_hsl": [
      0.05038759689922475,
      0.28476821192052965,
      0.7039215686274509
    ]
  },
  "DarkMuted": {
    "_rgb": [
      45,
      66,
      78
    ],
    "_population": 141,
    "_hsl": [
      0.5606060606060607,
      0.2682926829268293,
      0.24117647058823533
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Discovery-Of-Witches-A-S1.js